<div class="grid m-0 footer align-items-center">
    <div class="col-6 md:col-6 copyright-alignment">
        <span style="color: white;">© 2024 &nbsp;</span>
    </div>
    <div class="col-6 md:col-6 footer-logo-alignment"> 
        <img src="assets/footer_logo.png" >

    </div>
